import React from 'react';
import { apiFetch } from '../lib/api';

/**
 * Bandeau du filtre « Pour moi » de la cloche et du centre de notifications (accueil de pilotage, spec § 9, plan 5).
 *
 * Le SERVEUR décide (route `GET /api/notifications?pour_moi=1`) : il ne filtre que pour le dirigeant dont le réglage est
 * actif, et rend `pour_moi = { actif, hors_filtre }`. L'écran ne redécide rien : sans `actif`, pas de bandeau, et
 * tout autre compte voit sa cloche comme avant.
 *
 * - filtre actif, vue « Pour moi » : « Pour moi · N autres » et un lien « Tout voir (N) » ;
 * - vue « Tout voir » (choisie ici, le temps de l'ouverture) : « Toutes les notifications » et « Revenir à Pour moi ».
 */
export const ADRESSE_POUR_MOI = 'pour_moi=1';

/** L'adresse de la liste : `pour_moi=1` ajouté, sauf en vue « Tout voir ». */
export function adresseListe(base, toutVoir) {
  if (toutVoir) return base;
  return base + (base.includes('?') ? '&' : '?') + ADRESSE_POUR_MOI;
}

/** Note « Tout voir » au journal d'usage de l'accueil (réservé au dirigeant ; une panne ne gêne jamais la cloche). */
export function noterToutVoir() {
  try {
    const r = apiFetch('/api/me/pilotage/usage', {
      method: 'POST',
      body: JSON.stringify({ evenement: 'cloche_tout_voir' }),
    });
    if (r && typeof r.catch === 'function') r.catch(() => {});
  } catch { /* rien : ce n'est qu'une trace */ }
}

const LIEN = {
  background: 'none', border: 'none', padding: 0, cursor: 'pointer',
  color: 'var(--primary)', fontWeight: 600, fontSize: 'inherit', textDecoration: 'underline',
};

export default function BandeauPourMoi({ info, toutVoir, onToutVoir, onRevenir, style }) {
  if (!toutVoir && !(info && info.actif)) return null;
  const n = (info && Number.isInteger(info.hors_filtre)) ? info.hors_filtre : 0;
  return (
    <div role="status" aria-label="Filtre Pour moi" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap',
      padding: '8px 16px', fontSize: 12, color: 'var(--text-secondary)', background: 'var(--bg)',
      borderBottom: '1px solid var(--border-light)', ...style,
    }}>
      {toutVoir ? (
        <>
          <span>Toutes les notifications</span>
          <button type="button" style={LIEN} onClick={onRevenir}>Revenir à « Pour moi »</button>
        </>
      ) : (
        <>
          <span><strong>Pour moi</strong>{n > 0 ? ` · ${n} autre${n > 1 ? 's' : ''} à traiter` : ''}</span>
          <button type="button" style={LIEN} onClick={onToutVoir}>Tout voir ({n})</button>
        </>
      )}
    </div>
  );
}
